import Image from '@/components/image';
import NextLink from '@/components/next-link';
import { useLocale, useTranslations } from 'next-intl';

function GiftIcon({ className = '', color = '#059669' }) {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
    >
      <rect
        x='2'
        y='7'
        width='20'
        height='13'
        rx='2'
        stroke={color}
        strokeWidth='1.6'
      />
      <path d='M12 7v13' stroke={color} strokeWidth='1.6' />
      <path d='M2 11h20' stroke={color} strokeWidth='1.6' />
      <path
        d='M7.5 6a2.5 2.5 0 1 1 5 0c0 2-3 2-5 2 0-1 0-2 0-2Z'
        stroke={color}
        strokeWidth='1.6'
      />
      <path
        d='M11.5 6a2.5 2.5 0 1 1 5 0c0 2-3 2-5 2 0-1 0-2 0-2Z'
        stroke={color}
        strokeWidth='1.6'
      />
    </svg>
  );
}

function GiftRow({ t, note = null }) {
  return (
    <div
      className='flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2'
      aria-label='سطر هدية مجانية'
    >
      <GiftIcon />
      <div className='text-[13px] leading-5 text-slate-700'>
        <span className='text-primary font-bold'>{t('free_gift')}</span>
        <span className='mx-1'>— {note || t('free_gift_note')}</span>
      </div>
    </div>
  );
}

function ProductCard({ product, locale }) {
  const name = product?.[`product_name${locale === 'ar' ? '_ar' : ''}`];
  const price = product?.product_special_price || product?.product_price;
  // here page is PDP
  return (
    <NextLink
      href={`/${product?.url || '#'}`}
      className='flex items-center gap-3'
    >
      <Image
        src={`${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/catalog/product${product?.product_image}`}
        alt={name}
        className='h-16 w-16 shrink-0 rounded-md object-contain'
      />
      <div className='min-w-0'>
        <div className='truncate text-[14px] font-semibold text-slate-900'>
          {name}
        </div>
        {price && (
          <div className='text-primary mt-0.5 text-[13px] font-bold'>
            {price}
          </div>
        )}
      </div>
    </NextLink>
  );
}

export default function GiftItems({ data }) {
  const locale = useLocale();
  const t = useTranslations('product');
  return (
    <div className='grid grid-cols-1 gap-4 rounded-lg border border-slate-200 bg-white p-3 *:not-last:border-b *:not-last:border-slate-300 *:not-last:pb-3'>
      <GiftRow t={t} />
      {data?.map((item) => (
        <ProductCard product={item} key={item?.url} locale={locale} />
      ))}
    </div>
  );
}
